<script setup lang="ts">
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases.ts";
import { useAbilityRoute } from "@/shared/environment/ability-route.ts";
import { stringify } from "qs";
import { computed } from "vue";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";

const props = defineProps<{ product: string; asset: string }>();

const { getPathToChildWithoutParents } = useAbilityRoute();

const searchPath = computed(() => {
    const params: Record<string, string> = { text: "" };
    if (props.asset) params.asset = props.asset;
    if (props.product) params.product = props.product;

    return getPathToChildWithoutParents(
        CommonRouteAliases.search,
        { [CommonRouteAliases.search]: stringify(params) },
        { tab: "articles" }
    );
});
</script>

<template>
    <WidgetCard
        icon="fa-light icon-light-color fa-sitemap q-mr-sm"
        :title="$t('mechanic.Properties')"
        :description="$t('mechanic.Search parts based on properties')"
    >
        <template #button>
            <router-link :to="searchPath" class="button flex justify-end">
                <QitButton color="secondary" :label="$t('mechanic.Select properties')" />
            </router-link>
        </template>
    </WidgetCard>
</template>
